module.exports = __webpack_public_path__ + "media/images/profile-5182f41a7f49fb32379a4841c1f5f633.svg";